import {config, api, util} from '../../utils/index'
// 通过函数创建新对象，保证每次初始构建时都是新的
export default function(){
  return {
    namespaced: true,
    state: {    
      checkDataResult: {},
      // 包含经营体、剧院和场厅信息的数据
      baseInfoAll: {},
      // 图集基础信息，含视频url、其他图片的数量等
      galleryBasic: {},    
      // 技术参数图片列表
      galleryImgsTech: [],
      // 一般图片列表
      galleryImgs: [],
      serviceInfos: [],
      rearServiceInfos: [],
      // 初始指定时间段内的档期信息
      scheduleInfoInit: [],
      // 初始最近几个月(直到有某一个档期)内的档期信息
      scheduleInfoRecentMonthInit: []
    },
    getters: {
      // 剧院基础信息。根据baseInfoAll中信息计算得来，保存一份，避免每次get都计算和生成新对象。下面有类似的
      theaterBaseInfo(state,getters) {
        let res = state.baseInfoAll
        let theaterBaseInfo = res.TheaterBaseInfo
        let organEntiy = res.OrganEntiy
        if(organEntiy.EntityLogoUrl){
          theaterBaseInfo.EntityLogoUrl = util.dealRelativeUrl(organEntiy.EntityLogoUrl,config.resourceHost)
        }
        theaterBaseInfo.EntityName = organEntiy.EntityName
        theaterBaseInfo.EntityID = organEntiy.EntityID              
        theaterBaseInfo.listNumber = theaterBaseInfo.VenueTotal
        return theaterBaseInfo
      },
      // 场厅基础信息
      venueBaseInfo(state,getters) {
        let res = state.baseInfoAll
        let venueBaseInfo = null
        venueBaseInfo = res.VenueBaseInfo[0]
        let PerformanceTypes = []
        venueBaseInfo.PerformanceType.forEach(p => {
          PerformanceTypes.push(p.PerformanceTypeName)
        })
        venueBaseInfo.PerformanceTypeStr = PerformanceTypes.join('/')
        if(venueBaseInfo.FirstShowDate){
          venueBaseInfo.FirstShowDateStr = util.formatDate.format(new Date(venueBaseInfo.FirstShowDate),'yyyy.MM.dd')
        }
        if(venueBaseInfo.VenuePrice){
          venueBaseInfo.InComeSharing = venueBaseInfo.VenuePrice.InComeSharing
        }      
        return venueBaseInfo
      },
       // 可用于组件使用的图集数据。计算后存储
      swiperArr(state, getters) {
        let sliderData = state.galleryBasic
        let swiperArr = []
        sliderData.VenueADVideoUrl = util.buildAvailableVideoUrl(sliderData)
        // 视频
        if (sliderData.VenueADVideoUrl && sliderData.VenueADVideoUrl !== '') {
          if (
            sliderData.VenueADVideoUrl.startsWith('http://') ||
            sliderData.VenueADVideoUrl.startsWith('https://')
          ) {
            let processArgs =
              '?x-oss-process=video/snapshot,t_0,w_0,h_0,f_jpg,m_fast' // 根据视频源自动确定宽度和高度
            
            swiperArr.push({
              type: 'video',
              src: sliderData.VenueADVideoOptionalUrl || sliderData.VenueADVideoUrl,
              previewSrc: sliderData.VenueADVideoUrl + processArgs,
              isPasuse: true
            })
          } else {
            let adUrl = config.resourceHost + sliderData.VenueADVideoUrl
            let preAdUrl = adUrl.slice(0, adUrl.lastIndexOf('.')) + '_Preview.jpg'
            swiperArr.push({
              type: 'video',
              src: adUrl,
              previewSrc: preAdUrl,
              isPasuse: true
            })
          }
        }
        // 技术参数图片
        let galleryImgsTech = state.galleryImgsTech
        if (galleryImgsTech.length > 0) {
          let photoArr = []
          galleryImgsTech.forEach(r => {
            let photo = {
              src: util.dealRelativeUrl(r.UrlPreview, config.resourceHost),
              title: r.GalleryName,
              info: r.GalleryMemo
            }
            photoArr.push(photo)
          })
          swiperArr.push({
            type: 'imageTech',
            src: photoArr,
            previewSrc: photoArr[0].src,
            ImageCount: galleryImgsTech.length
          })
        }
        // 一般图片
        let galleryImgs = state.galleryImgs
        if (galleryImgs.length > 0) {
          let photoArr = []
          galleryImgs.forEach(r => {
            let photo = {
              src: util.dealRelativeUrl(r.UrlPreview, config.resourceHost),
              title: r.GalleryName,
              info: r.GalleryMemo
            }
            photoArr.push(photo)
          })
          swiperArr.push({
            type: 'image',
            src: photoArr,
            previewSrc: photoArr[0].src,
            ImageCount: galleryImgs.length
          })
        }
        return swiperArr
      },
      isShow(state, getters) {
        return state.checkDataResult.Result === 0
      },
      checkDataResultView(state, getters) {
        return state.checkDataResult
      },
      serviceInfos(state,getters) {
        // 显示处理
        let newServiceInfos = []
        let res = state.serviceInfos
        let serviceObj = {}
        res.forEach(service => {
          serviceObj ={
            Name: service.ServiceName,
            Items: []
          }
          service.Service.forEach(sItem => {
            serviceObj.Items.push({
              className: sItem.Name,
              classDetail: sItem.Detail
            })
          })
          if (serviceObj.Items.length > 0) {
            newServiceInfos.push(serviceObj)
          }            
        })
        return newServiceInfos
      },
      rearServiceInfos(state,getters) {
        // 显示处理
        let newServiceInfos = []
        let res = state.rearServiceInfos
        if (res.TheatreFood) {
          newServiceInfos.push({name: '餐饮服务',value: res.TheatreFood})
        }
        if (res.TheatreHotel) {
          newServiceInfos.push({ name: '住宿服务', value: res.TheatreHotel })
        }
        if (res.TheatreTraffic) {
          newServiceInfos.push({ name: '交通服务', value: res.TheatreTraffic })
        }
        return newServiceInfos
      }
    },
    actions: {
      getCheckData ({ commit }, data) {
        return api.checkVenue(data).then(res => {
          commit('checkDataResult', res)
        })
      },
      getBaseInfoAll ({ commit }, data) {
        return api.getTheaterVenueBaseInfo(data).then(res => {
          commit('baseInfoAll', res)
        })
      },
      getGalleryBasic ({ commit }, data) {
        return api.getVenueGalleryInfo(data).then(res => {
          commit('galleryBasic', res)
        })
      },
      getGalleryImgsTech ({ commit }, data) {
        return api.getVenueGalleryTech(data).then(res => {
          commit('galleryImgsTech', res)
        })
      },
      getGalleryImgs ({ commit }, data) {
        return api.getGalleryVenue(data).then(res => {
          commit('galleryImgs', res)
        })
      },
      getServiceInfos ({ commit }, data) {
        return api.getTheaterService(data).then(res => {
          commit('serviceInfos', res)
        })
      },
      getRearServiceInfos ({ commit }, data) {
        return api.getTheaterRearService(data).then(res => {
          commit('rearServiceInfos', res)
        })
      },
      getScheduleInfoInit ({ commit }, data) {
        return api.searchTheatreVenueScheduleInfoByOrder(data).then(res => {
          commit('scheduleInfoInit', res)
        })
      },
      getScheduleInfoRecentMonthInit ({ commit }, data) {
        return api.searchTheatreVenueScheduleInfoByOrderForRecentMonth(data).then(res => {
          commit('scheduleInfoRecentMonthInit', res)
        })
      }
    },
    mutations: {
      checkDataResult (state, data) {
        state.checkDataResult = data
      },
      baseInfoAll (state, data) {
        state.baseInfoAll = data
      },
      galleryBasic (state, data) {
        state.galleryBasic = data
      },
      galleryImgsTech (state, data) {
        state.galleryImgsTech = data
      },
      galleryImgs (state, data) {
        state.galleryImgs = data
      },
      serviceInfos (state, data) {
        state.serviceInfos = data
      },
      rearServiceInfos (state, data) {
        state.rearServiceInfos = data
      },
      scheduleInfoInit (state, data) {
        state.scheduleInfoInit = data
      },
      scheduleInfoRecentMonthInit (state, data) {
        state.scheduleInfoRecentMonthInit = data
      }
    }
  }
}

